import { userRepository } from '@/service/repository/userRepository'
import { cookieManager } from '@/service/cookieManager'

const LAST_TOKEN_REFRESH_AT_KEY = 'lastTokenRefreshAt'

const markTokenRefreshed = () => {
	try {
		localStorage.setItem(LAST_TOKEN_REFRESH_AT_KEY, Date.now().toString())
	} catch (_) {
		// localStorage may be unavailable
	}
}

const persistSession = (commit, sessionResult) => {
	commit('setUser', sessionResult)
	if (sessionResult.token) {
		cookieManager.setToken(sessionResult.token)
		markTokenRefreshed()
	}
}

const state = {
	user: null,
	userReservations: []
}

const getters = {
	firstReservation(state) {
		const allReservations = [...state.userReservations]
		allReservations.sort((a, b) => {
			const dateA = new Date(a.startDateTime)
			const dateB = new Date(b.startDateTime)
			return dateA - dateB
		})

		return allReservations.length > 0 ? allReservations[0] : false
	},
	user(state) {
		return state.user
	}
}

const mutations = {
	setUser(state, payload) {
		state.user = payload.user
	},
	loadUserReservations(state, payload) {
		state.userReservations = payload.userReservations
	},
	eraseReservation(state, payload) {
		state.userReservations = state.userReservations.filter(
			reservation => reservation.id !== payload.reservationId
		)
	}
}

const actions = {
	async find({ commit }, userId) {
		try {
			const findUserResult = await userRepository.find(userId)
			if (findUserResult?.result === 0) {
				persistSession(commit, findUserResult)
				return findUserResult
			}
			cookieManager.clearToken()
			return null
		} catch (error) {
			console.error('Error al cargar el usuario:', error)
			cookieManager.clearToken()
			return null
		}
	},

	async refreshSession({ dispatch, rootGetters }, { app = 'copilot', force = false, deviceToken = null } = {}) {
		const token = cookieManager.getToken()
		if (!token) return null

		const TOKEN_REFRESH_INTERVAL_MS = 6 * 60 * 60 * 1000 // 6 hours
		if (!force) {
			const last = parseInt(localStorage.getItem(LAST_TOKEN_REFRESH_AT_KEY) || '0', 10)
			if (Date.now() - last < TOKEN_REFRESH_INTERVAL_MS) {
				return rootGetters['user/user']
			}
		}

		return dispatch('loginWithToken', { token, app, deviceToken })
	},

	async loginWithToken({ commit }, { token, app = null, deviceToken = null } = {}) {
		const findUserResult = await userRepository.loginWithToken(token, app, deviceToken)
		if (findUserResult?.result === 0) {
			persistSession(commit, findUserResult)
			return findUserResult
		}
		if (findUserResult?.authFailure) {
			cookieManager.clearToken()
		}
		return null
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
}
